import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { AutocompleteItem } from '../AutocompleteItem';
import { RenderHighlightedParts } from '../../../../../components/highlight/RenderHighlightedParts';
import { ReactComponent as Enter } from '../../../../../../icons/subdirectory_arrow_left.svg';
import { autocompleteDelimiters } from '../autocompleteConstants';
import styles from './autocomplete_query_item.module.scss';
import { renderHighlightedParts } from './renderHighlightedParts';

type Props = {
  label: string;
  selected: boolean;
  item: string;
  onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

export const AutocompleteQueryItem: FC<Props> = ({
  selected,
  label,
  onClick,
  item,
}) => (
  <AutocompleteItem isSelected={selected} onClick={onClick}>
    <span className="search-bar-dropdown__cell" title={label}>
      <span className={styles.item}>
        <RenderHighlightedParts
          renderHighlightedParts={renderHighlightedParts}
          config={autocompleteDelimiters}
        >
          {item}
        </RenderHighlightedParts>
      </span>
      <span
        className={classNames(styles.enter, {
          [styles.selected]: selected,
        })}
      >
        <FormattedMessage id="search/components/search-bar/dropdown/query/AutocompleteQueryItem.tsx/1" />
        <Enter className={styles.icon} />
      </span>
    </span>
  </AutocompleteItem>
);
